import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { finalize, takeUntil } from 'rxjs/operators';

import { ToasterService } from 'common/src/modules/ui-components/toaster';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { FontsApiService } from '../../services';
import { FontModel } from '../../models';

@Component({
  selector: 'rnpl-add-font-button',
  templateUrl: './add-font-button.component.html',
  styleUrls: ['add-font-button.component.scss']
})
export class AddFontButtonComponent implements OnDestroy {

  private currentUploadedFile: File = null;

  @Input() shortList = false;

  @Output() fontAdded: EventEmitter<FontModel> = new EventEmitter<FontModel>();

  @ViewChild('UploadFileInput', {static: true}) public uploadFileInputEl: ElementRef;

  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private toasterService: ToasterService,
    private fontsApiService: FontsApiService,
  ) {
  }

  public uploadFile(filesList: FileList): void {
    if (!filesList || !filesList.length) { return; }
    if (filesList.length > 1) {
      this.toasterService.notify({type: 'error', message: 'DATA_IMPORT.SINGLE_FILE_ERROR'});
      return;
    }

    this.currentUploadedFile = filesList[0];
    this.uploadFileInputEl.nativeElement.value = null;
    this.postUploadedFile();
  }

  public postUploadedFile(): void {
    this.submitRequest$.next(true);

    this.toasterService.notifyRequestMessage({key: 'fileUploading', message: 'DATA_IMPORT.FILE_PROCESSING'});

    this.fontsApiService.addFont(this.currentUploadedFile)
      .pipe(
        finalize(() => {
          this.submitRequest$.next(false);
          this.toasterService.hideRequestMessage('fileUploading');
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((font: FontModel) => this.fontAdded.emit(font));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
